const CompanyInfo = {
    name: "Invoke HQ (Office 1)",
    address: "Sungai Besi, Kuala Lumpur",
    numEmployees: 100,
    longAddress: "Sungai Besi, Lorem Ipsum longer addres asdjai aisud aiusduia aisud"
}


export default CompanyInfo